module.exports = __webpack_public_path__ + "static/media/socialphoneDocIcon.82179313.svg";